import React from 'react'
import ReactOnRails from 'react-on-rails'
import * as Views from '../views/.index'
import { AppWrapper } from '../components/AppWrapper'

/**
 * Higher-Order Component that wraps view components with AppWrapper
 * to enable Chameleon.io integration for user tracking.
 */
function withChameleon(Component) {
  function WrappedComponent(props) {
    return (
      <AppWrapper currentUser={props.currentUser} chameleonHash={props.chameleonHash}>
        <Component {...props} />
      </AppWrapper>
    )
  }

  // Preserve display name for debugging
  WrappedComponent.displayName = `withChameleon(${Component.displayName || Component.name || 'Component'})`

  return WrappedComponent
}

// Register components directly
const components = {}

// Register each component wrapped with Chameleon integration
Object.entries(Views).forEach(([name, component]) => {
  const wrappedComponent = withChameleon(component)

  // Register with exact name
  components[name] = wrappedComponent

  // Also register with lowercase name for flexibility
  components[name.toLowerCase()] = wrappedComponent
})

ReactOnRails.register(components)
